// extracted by mini-css-extract-plugin
export default {"slideContainer":"_23mpL","slide":"d-6Vu"};